import { render, staticRenderFns } from "./userSidebar.vue?vue&type=template&id=6cb953f5&scoped=true&"
import script from "./userSidebar.vue?vue&type=script&lang=js&"
export * from "./userSidebar.vue?vue&type=script&lang=js&"
import style0 from "./userSidebar.vue?vue&type=style&index=0&id=6cb953f5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb953f5",
  null
  
)

export default component.exports